import { render, staticRenderFns } from "./CommunitiesGrid.vue?vue&type=template&id=277809de&scoped=true&"
import script from "./CommunitiesGrid.vue?vue&type=script&lang=js&"
export * from "./CommunitiesGrid.vue?vue&type=script&lang=js&"
import style0 from "./CommunitiesGrid.vue?vue&type=style&index=0&id=277809de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277809de",
  null
  
)

export default component.exports